import React, {useState, useEffect} from "react"
import _ from "lodash"
import { navigate, RouteComponentProps } from "@reach/router"

import CarouselContent from 'components/table/carousel/carousel-content'
import CreditLossBasic from 'components/property-market/vacancy-credit-loss/controls/credit-loss-basic'
import CreditLossDetailed from 'components/property-market/vacancy-credit-loss/controls/credit-loss-detailed'
import VacancyLossBasic from 'components/property-market/vacancy-credit-loss/controls/vacancy-loss-basic'
import VacancyLossDetailed from 'components/property-market/vacancy-credit-loss/controls/vacancy-loss-detailed'
import { TextInput } from "components/table/carousel/inputs"
import { updateValidation } from "components/table/table-automation"

import api_match from "data/interface/api"
import carouselService from 'data/carousel'
import propertyService from 'data/property'
import tenantGroupService from 'data/tenant-group'

import { Label_s } from 'styles/app-styles'
import { AccountNumber_s, VacancyCreditLoss_s } from 'components/property-market/property-market-styles'

const VacancyCreditLoss = (props: RouteComponentProps) => {
  const [property, setProperty] = useState<object|null>(null);
  const [propertyId, setPropertyId] = useState(propertyService.getStoredPropertyId())
  const [tenantGroups, setTenantGroups] = useState([{}]);
  const [showVacancyLoss, toggleShowVacancyLoss] = useState<boolean>(true);
  const [showCreditLoss, toggleShowCreditLoss] = useState<boolean>(false);

  const persist = (value, field, rowData) => {
    const val = value['index'] ? _.omit(_.cloneDeep(value), 'index') : value;
    const updatedProperty = _.cloneDeep(property);

    if (value.state && updatedProperty[field].state !== value.state){
      updatedProperty[field] = { state: value.state }
    }

    _.set(updatedProperty, field, val);
    propertyService.patch(updatedProperty);

    if (val && val.state) carouselService.updateRowData(val);
    updateValidation();
  }

  useEffect(() => {
    const propertySubscription = propertyService.stream().subscribe((data) => {
      if (data.value.length > 0){
        let property = _.find(data.value, {propertyid: data.current});
        switch(true){
          case property.type === 'Multifamily':
            navigate("/n/multifamily/rent-roll")
            break
          default:
            setProperty(property)
            setPropertyId(propertyService.getStoredPropertyId())
        }
      }

      switch (data.state) {
        case 'ok':
          if (data.current !== propertyId) setPropertyId(data.current)
          break
      }
    })

    const tenantGroupSubscription = tenantGroupService.stream().subscribe(data => {
      api_match(
        data,
        init  => setTenantGroups(init.value),
        ok    => {
          if(ok.value.length) { // sort only on first load
            setTenantGroups(ok.value)
          } else {
            setTenantGroups(ok.value)
          }
        },
        err   => {
          setTenantGroups(err.value) // backout any optimistic updates
        },
        fetch => {}
      )
    })

    return function cleanup() {
      propertySubscription.unsubscribe()
      tenantGroupSubscription.unsubscribe()
    }
  }, [])

  useEffect(() => {
    if (_.isNil(propertyId)) return
    propertyService.fetchProperty(propertyId)
    tenantGroupService.fetchTenantGroups(propertyId)
  }, [propertyId])

  useEffect(() => {

  }, [property])

  if (property && tenantGroups) {
    return (
      <VacancyCreditLoss_s>
        <details open={showVacancyLoss} onClick={e => {
          e.preventDefault();
          toggleShowVacancyLoss(true);
          toggleShowCreditLoss(false);
          updateValidation();
        }}>
          <summary>Vacancy Loss Account | <strong>{property['vacancylossaccountnumber'] || ""}</strong></summary>
          {showVacancyLoss &&
          <div>
            <AccountNumber_s>
              <Label_s>Account #</Label_s>
              <TextInput className="automated" data={property} field="vacancylossaccountnumber" persist={persist} />
            </AccountNumber_s>
            <CarouselContent
              outsideTable={true}
              controls={{basic: {control: VacancyLossBasic, name: "Basic"}, detailed: {control: VacancyLossDetailed, name: "Detailed"}}}
              field='vacancylossdetail'
              data={{'vacancylossdetail': property['vacancylossdetail'], 'vacancylossaccountnumber': property['vacancylossaccountnumber'], propertyid: property['propertyid']}}
              namedItems={{tenantGroups, propertyId}}
              persist={persist}
            />
          </div>}
        </details>
        <details open={showCreditLoss} onClick={e => {
          e.preventDefault();
          toggleShowCreditLoss(true);
          toggleShowVacancyLoss(false);
          updateValidation();
        }}>
          <summary>Credit Loss Account | <strong>{property['creditlossaccountnumber'] || ""}</strong></summary>
          {showCreditLoss &&
          <div>
            <AccountNumber_s>
              <Label_s>Account #</Label_s>
              <TextInput className="automated" data={property} field="creditlossaccountnumber" persist={persist} />
            </AccountNumber_s>
            <CarouselContent
              outsideTable={true}
              controls={{basic: {control: CreditLossBasic, name: "Basic"}, detailed: {control: CreditLossDetailed, name: "Detailed"}}}
              field='creditlossdetail'
              data={{'creditlossdetail': property['creditlossdetail'], propertyid: property['propertyid']}}
              namedItems={{tenantGroups, propertyId}}
              persist={persist}
            />
          </div>}
        </details>
      </VacancyCreditLoss_s> )
    } else {
      return null
    }
}

export default VacancyCreditLoss
